import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2466465509/src/apps/pickuji/src/components/ui/Tab/Tab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2466465509/src/apps/pickuji/src/features/lottery/components/LotteryInfiniteList/LotteryInfiniteList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2466465509/src/apps/pickuji/src/features/lottery/components/LotteryListHeader/LotteryListHeader.tsx");
